module.exports = __webpack_public_path__ + "static/media/todo.21fb02a3.svg";